import React, { useEffect, useState } from "react";

import DstButton from "../../../../../components/DstButton/DstButton";
import DstTabsVertical from "../../../../../components/DstTabsVertical/DstTabsVertical";
import Popup from "../../../../../components/Popup/Popup";
import translate from "../../../../../services/Translate";
import { sprintObject } from "../CohortSprint.d";
import { buildPopupTabs } from "./CohortSprintPopup.function";

export const _handleAddNewSprint = (setSprints: Function, setActiveKey: Function) => {
  setSprints((prevSprints: sprintObject[]) => {
    const newSprint = {
      sprint: {
        name: `Sprint ${prevSprints.length + 1}`,
        dt_start: "",
        dt_end: "",
      },
      modules: [],
    };

    setActiveKey(`sprint-${prevSprints.length}`);

    return [...prevSprints, newSprint];
  });
};

const CohortSprintPopup = ({
  language,
  showPopup,
  setShowPopup,
  activeKey,
  setActiveKey,
  existingSprints,
  handleSaveSprints,
}: {
  language: string;
  showPopup: boolean;
  setShowPopup: Function;
  activeKey: string;
  setActiveKey: Function;
  existingSprints: sprintObject[];
  handleSaveSprints: Function;
}) => {
  const [isSending, setIsSending] = useState(false);
  const [sprints, setSprints] = useState<sprintObject[]>([]);

  const _deleteSprint = (indexToDelete: number) => {
    setSprints((prev) => prev.filter((_, index) => index !== indexToDelete));

    if (activeKey === `sprint-${indexToDelete}` && sprints.length > 1) {
      const nextIndex = indexToDelete === 0 ? 0 : indexToDelete - 1;
      setActiveKey(`sprint-${nextIndex}`);
    }
  };

  useEffect(() => {
    if (existingSprints.length > 0) {
      setSprints([...existingSprints]);
      setActiveKey("sprint-0");
    }
  }, [showPopup, existingSprints, setActiveKey]);

  return (
    <Popup
      show={showPopup}
      onClose={() => setShowPopup(false)}
      modalTitle={translate(language, "PAGES.COHORT.SPRINT.POPUP.TITLE")}
      removePadding
      size="xl"
      footerContent={
        <DstButton
          value={translate(language, "PAGES.COHORT.SPRINT.POPUP.INFO_SPRINT.BUTTON_SAVE")}
          variant="primary"
          btnClass="px-4"
          loading={isSending}
          disabled={isSending}
          clickFunction={() => {
            setIsSending(true);
            handleSaveSprints(sprints, language, () => {
              setIsSending(false);
              setShowPopup(false);
            });
          }}
        />
      }
    >
      <DstTabsVertical
        titleIcon={<React.Fragment></React.Fragment>}
        classes="pt-0"
        bodyClass="medium-gray-background"
        activeKey={activeKey}
        onSelect={(key: any) => key && setActiveKey(key)}
        fullHeight
        tabsData={buildPopupTabs(language, sprints, setSprints, _deleteSprint)}
        variant="light"
        TabsSize={{ xl: 3, lg: 4, xs: 3 }}
        customButtonComponent={
          <DstButton
            value={translate(language, "PAGES.COHORT.SPRINT.POPUP.ADD_SPRINT")}
            variant="light"
            backgroundColor="--var(--color-medium-gray)"
            color="var(--color-black)"
            btnClass="w-fit my-3 custom-btn-role m-3"
            btnImageBefore={<span className="dst-icon-plus-circle me-2" />}
            clickFunction={() => _handleAddNewSprint(setSprints, setActiveKey)}
          />
        }
      />
    </Popup>
  );
};

export default CohortSprintPopup;
